export const DASHBOARD = '/dashboard/'
export const DASHBOARD_STUDENT = `${DASHBOARD}student`
